import * as React from "react";

const WomanArcade = props => (
  <svg data-name="Layer 1" {...props} viewBox="0 0 1111.03 836.33">
    <path
      d="M935.14 163.87c7.28 69.4 64 127.57 117.56 166.57 17.92 13.06 37.27 26.52 48.57 48 13.81 26.21 11.38 57.12 2.53 80.58-16.12 42.77-52.19 70-93.91 70.84-36 .74-74.57-16.88-110.36-14.87-59.9 3.32-99.32 60.18-124.78 120.4-18 42.6-35.45 92.38-75.5 103-28.18 7.5-61.6-7.22-89.82-29.56-13.63-10.79-27.07-23.69-42-28.4-8.86-2.8-17.63-2.46-26-1.25-76.51 11.09-127.05 90.99-204.92 96.62-52.59 3.84-110.19-27.91-157.43-73S93.34 600.02 56.84 542.17C30.9 501.06 4.44 456.01.51 409.23c-4.21-49.5 19-91.06 51.77-111.67s74-23 114.73-18.56c50.94 5.53 105.34 20.87 149.36 1.19 30-13.4 51.59-41.69 74.93-66.35 39-41.22 84.39-73.4 129.94-104.75 43.6-30 88-59.64 138-76 35.44-11.61 73.1-7.69 109.51-14.43 23.74-4.39 43.48-18 68.42-18.59 30.72-.78 68.63 12.43 87.89 51.4 18.34 37.01 6.21 75.57 10.08 112.4Z"
      fill="#6c63ff"
      opacity={0.1}
    />
    <path
      d="m834.57 45.45-68.3-4.14-39.52-2.82v-.07h-1.04v.08l-212.51 17h-17.62l-2.07 73.35 34.21 12.06 20.73 105.5-94.33 186.87-57 43.2v41.19l34.21 33.16 2.07 151.72 10.37 2v-1.61l5.21 1v.6l202.45 68.08 8.51 5.77 17.8-11.09 143.4-82.85ZM616.92 516.77l55.46-47Zm-192.35 19.5 15 14.57v.9Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#9a623e6e-caf0-4d64-85ef-a44d2d775d4e-116)"
    />
    <path fill="#535461" d="m407.35 522.08 202 51-30-34-17-21-177-35-8 7 30 32z" />
    <path fill="#d6d6e3" d="m377.35 490.08 199 46 1-48-57-22-114-19h-33l4 43zM521.35 218.08l203 13v-38l-14-85-7-6-203 6 21 110z" />
    <path
      fill="#d6d6e3"
      d="M473.35 27.08h-10l-2 73 33 12 20 105-91 186-55 43v41l33 33 2 151 10 2-2-150-33-35-1-42 53-42 93-186-20-106-33-14 3-71z"
    />
    <path
      fill="#535461"
      d="M465.35 27.08h-10l-2 73 33 12 20 105-91 186-55 43v41l33 33 2 151 10 2-2-150-33-35-1-42 55-42 91-186-20-106-33-14 3-71z"
    />
    <path fill="#a8a8a8" d="m464.85 92.58 5 7 28 13 222-6-21.5-6.5-23-10 3-8-213.5 10.5z" />
    <path fill="#0F74E7" d="m427.35 407.08 203 33 41-87 56-125-206-10-94 189z" />
    <path fill="#fff" d="m532.35 254.08 137 11-71 140-133-20 67-131z" opacity={0.1} />
    <path
      fill="#fff"
      d="m541.8 264.25 6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM542.8 322.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM575.8 271.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM638.8 274.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM553.8 282.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM575.8 343.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM521.8 308.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM613.8 271.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM565.8 305.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM558.8 267.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM589.8 302.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM596.8 271.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78zM533.8 285.25l6.05.49-3.13 6.17-5.87-.88 2.95-5.78z"
      opacity={0.1}
    />
    <path fill="#d6d6e3" d="m373.35 447.08 198 40 54.54-47.72-198.04-33.78-54.5 41.5z" />
    <path fill="#535461" d="M410.35 517.08v156l196 68 3-162-8-15.07-36-8.93-155-38z" />
    <ellipse cx={435.85} cy={420.08} rx={8.5} ry={5} fill="#575988" />
    <ellipse cx={442.85} cy={431.08} rx={8.5} ry={5} fill="#fa595f" />
    <ellipse cx={418.85} cy={428.08} rx={8.5} ry={5} fill="#ffd037" />
    <ellipse cx={526.85} cy={438.08} rx={8.5} ry={5} fill="#575988" />
    <ellipse cx={509.85} cy={447.08} rx={8.5} ry={5} fill="#ffd037" />
    <ellipse cx={477.85} cy={432.08} rx={12.5} ry={6} fill="#a8a8a8" />
    <ellipse cx={535.85} cy={449.08} rx={8.5} ry={5} fill="#F095B4" />
    <path d="M481.35 431.09h-6l-5.16-19.92a5.67 5.67 0 0 1 5.49-7.09 5.67 5.67 0 0 1 5.67 5.67Z" fill="#a8a8a8" />
    <ellipse cx={567.85} cy={448.08} rx={12.5} ry={6} fill="#a8a8a8" />
    <path d="M571.35 447.09h-6l-5.16-19.92a5.67 5.67 0 0 1 5.49-7.09 5.67 5.67 0 0 1 5.67 5.67Z" fill="#a8a8a8" />
    <path fill="#535461" d="m472.35 27.08 206-17-5 75-206 10 5-68z" />
    <path fill="#d6d6e3" d="m677.35 10.08 95 7-13 636-145.5 93.5-10-7-.5-166.5-32-36v-50l56-49 95-211-13.5-120.5h7l-44.5-15.5 6-81z" />
    <path fill="#535461" d="m686.35 11.08 96 6-13 636-156 93v-173l-32-36v-50l56-49 95-211-17-121-34-15 5-80z" />
    <path
      d="M561.95 428.21c-14 29-48.46 21.48-48.46 21.48-1.78-1.65-12.92-4.41-21.37-6.32-5.42-1.23-9.73-2.09-9.73-2.09l11.83-16.49 8.87 1.82 13.23 2.72s59.68-30.11 45.63-1.12Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#27839906-647e-4714-8b82-00411afaaa9d-117)"
    />
    <path
      d="M561.95 428.21c-14 29-48.46 21.48-48.46 21.48-1.78-1.65-12.92-4.41-21.37-6.32-5.42-1.23-9.73-2.09-9.73-2.09l11.83-16.49 8.87 1.82 13.23 2.72s59.68-30.11 45.63-1.12Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#27839906-647e-4714-8b82-00411afaaa9d-117)"
      opacity={0.08}
    />
    <path
      d="m503.1 426.61-11 16.77c-5.42-1.23-9.73-2.09-9.73-2.09l11.83-16.49Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#019c00cb-56c9-415d-990c-d992997e4242-118)"
      opacity={0.1}
    />
    <path
      d="M380.12 366.67s51.57 80.59 106.79 80.4l15-23s-50.54-36.1-57.26-54.92c-2.48-7-7.6-16.59-13.06-26-16.77-28.83-62-10-52.06 21.68q.29.94.59 1.84Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#231821a7-8fe6-4f40-9490-9a81b384aeef-119)"
    />
    <path
      d="M380.12 366.67s51.57 80.59 106.79 80.4l15-23s-50.54-36.1-57.26-54.92c-2.48-7-7.6-16.59-13.06-26-16.77-28.83-62-10-52.06 21.68q.29.94.59 1.84Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#231821a7-8fe6-4f40-9490-9a81b384aeef-119)"
      opacity={0.05}
    />
    <path
      d="m346.55 835.1 2.42 28s79.21-13.16 78.52-39.47-80.94 11.47-80.94 11.47Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#ae18a487-9ffc-47bd-8f52-b3a16e5ff5c8-120)"
    />
    <path
      d="m346.55 835.1 2.42 28s79.21-13.16 78.52-39.47-80.94 11.47-80.94 11.47Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#ae18a487-9ffc-47bd-8f52-b3a16e5ff5c8-120)"
      opacity={0.1}
    />
    <path
      d="m439.25 843.87-1.38 24.29s110-8.1 105.84-31S481.45 827 481.45 827Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#55e06269-ab84-4259-86ac-b336e5465e15-121)"
    />
    <path
      d="M440.63 606.37s-6.5 18-14.8 38.62c-7.94 19.74-17.52 41.93-24.63 53.14-14.53 22.94-16.6 93.79-16.6 93.79-2.77 11.47 11.07 33.74 11.07 33.74-27.67 29-53.27 12.15-53.27 12.15 4.84-8.77-3.46-33.74-3.46-33.74s11.07-115.38 18-120.78 12.45-32.39 12.45-32.39l-6.19-91.72-1.42-21 59.49-26.31 4.29 20.92 4.25 20.71Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#0a1d47d7-d222-4d2a-84f6-1160d51d618c-122)"
    />
    <path
      d="M440.63 606.37s-6.5 18-14.8 38.62c-7.94 19.74-17.52 41.93-24.63 53.14-14.53 22.94-16.6 93.79-16.6 93.79-2.77 11.47 11.07 33.74 11.07 33.74-27.67 29-53.27 12.15-53.27 12.15 4.84-8.77-3.46-33.74-3.46-33.74s11.07-115.38 18-120.78 12.45-32.39 12.45-32.39l-6.19-91.72-1.42-21 59.49-26.31 4.29 20.92 4.25 20.71Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#0a1d47d7-d222-4d2a-84f6-1160d51d618c-122)"
      opacity={0.1}
    />
    <path
      d="M492.51 829.71c-12.45 21.59-56 18.89-56 18.89v-63.43s-12.45-70.85-5.53-87-2.77-45.88-2.77-45.88l-2.38-7.29-28.21-87-8.18-25.22h93.39v11.34c.12 27 .68 93.91 3.43 109.44 3.46 19.57-6.23 32.39-6.23 32.39s5.53 79.62.69 104.58 11.79 39.18 11.79 39.18Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#68af950a-3acb-4036-a310-20f1e00a0aa7-123)"
    />
    <path
      d="M415.73 236.61s-14.53 39.13-43.58 53.3 47.73 18.22 47.73 18.22 12.45-29.69 40.81-50.61Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#0ce50e0a-8288-45d6-a68e-f9c25cfd9357-124)"
    />
    <path
      d="M482.86 544.16c-11.58 2.23-32.07 6.05-53.06 9.37-11 1.74-22.12 3.34-32.18 4.5-15.48 1.79-28.43 2.54-34.43 1.14l-1.42-21 59.49-26.31 4.29 20.92h57.28s0 4.36.03 11.38Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#2468d3b2-8c71-46f1-86a0-8806dd38ede0-125)"
      opacity={0.1}
    />
    <path
      d="M492.51 540.24s-116.91 23.62-131.43 16.2-18-26.31-13.84-47.23 0-72.87-7.61-139c-3.83-33.3 4.61-55.65 13.95-69.63a44.41 44.41 0 0 1 37-19.43 56 56 0 0 1 34.87 12c2.92 2.33 5.87 4.24 8.28 4.89 1.9.51 4.76 2.53 8 5.28A73.67 73.67 0 0 1 467 352.23c1.2 12.57 2.47 28.4 3.09 44.4a361 361 0 0 1-.42 41 134.37 134.37 0 0 0 1.42 29.91c5.39 36.46 21.42 72.7 21.42 72.7Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#ab82eb9a-10bc-4015-8c83-c1b3ce6172f0-126)"
    />
    <path
      d="M471.1 467.59c-42.43-25.82-64.37-98.06-64.37-98.06 0-.63 0-1.25-.07-1.86-.95-33.13 47.83-39.51 56.11-7.36 2.69 10.47 5 21.09 5.48 28.43a30.39 30.39 0 0 0 1.85 7.89 361 361 0 0 1-.42 41 134.37 134.37 0 0 0 1.42 29.96Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#8509957c-49db-4aed-8978-fce3b7f533d4-127)"
      opacity={0.1}
    />
    <path
      d="M408.46 259.89c6.9 11.41 12.36 22.9 26.37 24.85a126.9 126.9 0 0 1 23.78-23.16l-45-20.92s2.64 7.14-5.15 19.23Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#c54b3c11-abda-43bb-8a8d-1fa56ce4f5d1-128)"
      opacity={0.1}
    />
    <ellipse cx={398.91} cy={204.77} rx={45.66} ry={44.53} fill="url(#40d04a76-1424-458b-b947-a5bfbc7d42f2-129)" />
    <path
      d="M488.53 250.57a9.33 9.33 0 0 0 5.36-1.42c2.19-1.59 2.89-4.44 3.39-7.06 1.19-6.19 2.12-12.71 0-18.67-1.37-3.94-4-7.35-5.84-11.09-4.1-8.17-4.83-18-10.68-25.09-3.65-4.44-16.48 0-21.84-2.24-11.52-4.84-16.52-14.66-29.07-14.65a46.37 46.37 0 0 0-13.62 1.7c-5.61 1.73-10.57 5-15.18 8.59-8 6.22-15.84 14.76-15.13 24.74.46 6.37 4.35 12 6.64 17.94 3.84 10 3.14 21.24.37 31.6-1.18 4.41-2.53 9.68.6 13.05 2 2.11 5.17 2.71 8 2.25a26.64 26.64 0 0 0 8-3.2c4.5-2.39 9.06-4.82 12.7-8.33 2.41-2.32 4.35-5.06 6.64-7.49a73.4 73.4 0 0 1 15.1-12c4.43-2.66 9-1 13.65.73 10.22 3.75 19.67 10.84 30.91 10.64Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#5ce16e99-e1d1-4913-b330-fcfdc7b7fa41-130)"
      opacity={0.1}
    />
    <path
      d="M487.84 249.89a9.33 9.33 0 0 0 5.36-1.42c2.19-1.59 2.89-4.44 3.39-7.06 1.19-6.19 2.12-12.71 0-18.67-1.37-3.94-4-7.35-5.84-11.09-4.1-8.17-4.83-18-10.68-25.09-3.65-4.44-15.79.68-21.15-1.57-11.52-4.84-17.21-15.33-29.76-15.32a46.37 46.37 0 0 0-13.62 1.7c-5.61 1.73-10.57 5-15.18 8.59-8 6.22-15.84 14.76-15.13 24.74.46 6.37 4.35 12 6.64 17.94 3.84 10 3.14 21.24.37 31.6-1.18 4.41-2.53 9.68.6 13.05 2 2.11 5.17 2.71 8 2.25a26.64 26.64 0 0 0 8-3.2c4.5-2.39 9.06-4.82 12.7-8.33 2.41-2.32 4.35-5.06 6.64-7.49a73.4 73.4 0 0 1 15.1-12c4.43-2.66 9-1 13.65.73 10.22 3.75 19.67 10.84 30.91 10.64Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#4b9461a6-5ec4-4f73-8b59-40f8951be702-131)"
    />
    <path
      d="M471.1 467.59a134.37 134.37 0 0 1-1.42-29.91 361 361 0 0 0 .42-41c-.62-16-1.88-31.83-3.09-44.4a73.67 73.67 0 0 0-25.33-48.94c-3.21-2.75-6.07-4.78-8-5.28-2.41-.64-5.36-2.56-8.28-4.89-9.82-7.83 2.66 7.42 5.87 10.17a73.67 73.67 0 0 1 25.33 48.94c1.2 12.57 2.47 28.4 3.09 44.4a361 361 0 0 1-.42 41 134.37 134.37 0 0 0 1.42 29.91c5.38 36.43 21.41 72.65 21.41 72.65s-78.26 15.81-114.68 17.49c28.54 2 125.05-17.49 125.05-17.49S476.48 504 471.1 467.59Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#e3604d36-f40d-4186-a927-9dbaf3781bd2-132)"
      opacity={0.05}
    />
    <path
      d="M566.53 474.12c-21.45 24.29-52.57 8.1-52.57 8.1-1.27-2.06-11.25-7.61-18.86-11.65-4.89-2.59-8.81-4.55-8.81-4.55l15.91-12.82 8.05 4.06 12 6.06s65.75-13.49 44.28 10.8Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#2fa73d01-fdfe-4305-bc58-d4f4516ffda0-133)"
    />
    <path
      d="m510.25 457.26-15.15 13.31c-4.89-2.59-8.81-4.55-8.81-4.55l15.91-12.82Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#c580d740-0609-4a8d-8b93-2823000eeb05-134)"
      opacity={0.1}
    />
    <path
      d="M408.12 367.51s27.67 91.09 80.94 105.26l20.75-18.22s-38.81-47.94-40.17-67.83c-.49-7.35-2.79-18-5.48-28.43-8.28-32.14-57.06-25.77-56.11 7.36q.03.92.07 1.86Z"
      transform="translate(-44.49 -31.83)"
      fill="url(#3a3f1fbb-e5c8-4212-ad65-595049b5103a-135)"
    />
    <path
      d="M354.51 456.24s18-14.17 34.59-3.37 40.81 9.45 44.27 10.12"
      transform="translate(-44.49 -31.83)"
      opacity={0.05}
      fill="url(#557e2b40-a269-4a6b-b7c4-b92691329eac-136)"
    />
    <path
      d="M512.28 394.9c-13.35 28.28-46.12 21-46.12 21-1.7-1.61-12.3-4.3-20.33-6.16-5.16-1.2-9.26-2-9.26-2l11.26-16.09 8.44 1.78 12.59 2.65s56.77-29.47 43.42-1.18Z"
      fill="#f7c4a7"
    />
    <path
      d="M512.28 394.9c-13.35 28.28-46.12 21-46.12 21-1.7-1.61-12.3-4.3-20.33-6.16-5.16-1.2-9.26-2-9.26-2l11.26-16.09 8.44 1.78 12.59 2.65s56.77-29.47 43.42-1.18Z"
      opacity={0.08}
    />
    <path d="m456.27 393.33-10.44 16.36c-5.16-1.2-9.26-2-9.26-2l11.26-16.09Z" opacity={0.1} />
    <path
      d="M339.24 334.85s49.08 78.64 101.62 78.44l14.29-22.4s-48.09-35.22-54.49-53.59c-2.36-6.78-7.23-16.18-12.42-25.34-16-28.12-59-9.75-49.55 21.16l.55 1.73Z"
      fill="#575988"
    />
    <path
      d="M339.24 334.85s49.08 78.64 101.62 78.44l14.29-22.4s-48.09-35.22-54.49-53.59c-2.36-6.78-7.23-16.18-12.42-25.34-16-28.12-59-9.75-49.55 21.16l.55 1.73Z"
      opacity={0.05}
    />
    <path d="m307.29 791.9 2.3 27.32s75.38-12.84 74.72-38.51-77.02 11.19-77.02 11.19Z" fill="#535461" />
    <path d="m307.29 791.9 2.3 27.32s75.38-12.84 74.72-38.51-77.02 11.19-77.02 11.19Z" opacity={0.1} />
    <path d="m395.51 800.46-1.32 23.71s104.68-7.9 100.73-30.28-59.25-9.88-59.25-9.88Z" fill="#535461" />
    <path
      d="M396.82 568.72s-6.19 17.54-14.09 37.68c-7.56 19.26-16.68 40.91-23.44 51.85-13.78 22.39-15.78 91.51-15.78 91.51-2.63 11.19 10.53 32.92 10.53 32.92-26.33 28.31-50.69 11.85-50.69 11.85 4.61-8.56-3.29-32.92-3.29-32.92s10.53-112.58 17.12-117.84 11.84-31.6 11.84-31.6l-5.89-89.49-1.35-20.45 56.62-25.68 4.11 20.41 4 20.21Z"
      fill="#6a5c99"
    />
    <path
      d="M396.82 568.72s-6.19 17.54-14.09 37.68c-7.56 19.26-16.68 40.91-23.44 51.85-13.78 22.39-15.78 91.51-15.78 91.51-2.63 11.19 10.53 32.92 10.53 32.92-26.33 28.31-50.69 11.85-50.69 11.85 4.61-8.56-3.29-32.92-3.29-32.92s10.53-112.58 17.12-117.84 11.84-31.6 11.84-31.6l-5.89-89.49-1.35-20.45 56.62-25.68 4.11 20.41 4 20.21Z"
      opacity={0.1}
    />
    <path
      d="M446.2 786.63c-11.85 21.07-53.33 18.43-53.33 18.43v-61.89s-11.85-69.13-5.27-84.93-2.63-44.77-2.63-44.77l-2.24-7.08-26.85-84.84-7.78-24.6h88.88v11.07c.11 26.33.65 91.63 3.27 106.78 3.29 19.09-5.93 31.6-5.93 31.6s5.27 77.68.66 102 11.22 38.23 11.22 38.23Z"
      fill="#6a5c99"
    />
    <path d="M373.12 207.95s-13.83 38.18-41.48 52 45.43 17.78 45.43 17.78 11.85-29 38.84-49.38Z" fill="#f7c4a7" />
    <path
      d="M437.01 508.03c-11.02 2.14-30.5 5.9-50.5 9.14-10.46 1.7-21.05 3.26-30.63 4.39-14.73 1.74-27.06 2.48-32.77 1.11l-1.35-20.45 56.62-25.68 4.13 20.42h54.51s-.04 4.21-.01 11.07Z"
      opacity={0.1}
    />
    <path
      d="M446.2 504.17s-111.26 23-125.08 15.8-17.12-25.68-13.17-46.08 0-71.1-7.24-135.62c-3.65-32.49 4.39-54.29 13.27-67.94a42 42 0 0 1 35.2-19 52.41 52.41 0 0 1 33.18 11.69c2.78 2.27 5.59 4.14 7.88 4.77 1.81.49 4.53 2.47 7.58 5.15a72.49 72.49 0 0 1 24.11 47.75c1.15 12.26 2.35 27.71 2.94 43.33a361.13 361.13 0 0 1-.39 40 134.37 134.37 0 0 0 1.35 29.18c5.11 35.66 20.37 70.97 20.37 70.97Z"
      fill="#575988"
    />
    <path
      d="M425.82 433.32c-40.38-25.19-61.26-95.68-61.26-95.68 0-.61 0-1.22-.07-1.81-.9-32.32 45.52-38.55 53.4-7.18 2.56 10.22 4.75 20.57 5.21 27.74a30.28 30.28 0 0 0 1.76 7.7 361.13 361.13 0 0 1-.39 40 134.37 134.37 0 0 0 1.35 29.23ZM366.21 230.66c6.56 11.13 11.76 22.35 25.1 24.24a122.24 122.24 0 0 1 22.63-22.6l-42.79-20.41s2.47 6.98-4.94 18.77Z"
      opacity={0.1}
    />
    <circle cx={399.46} cy={207.95} r={43.45} fill="#f7c4a7" />
    <path
      d="M442.41 221.57a8.72 8.72 0 0 0 5.1-1.4c2.08-1.55 2.75-4.34 3.22-6.89 1.13-6 2-12.4 0-18.22-1.3-3.85-3.77-7.17-5.56-10.82-3.91-8-4.6-17.56-10.16-24.48-3.48-4.33-15.68 0-20.79-2.19-11-4.72-15.72-14.3-27.66-14.29a43.1 43.1 0 0 0-13 1.66c-5.34 1.68-10.06 4.9-14.44 8.38-7.64 6.07-15.08 14.4-14.4 24.14.44 6.22 4.14 11.66 6.32 17.5 3.66 9.78 3 20.73.35 30.83-1.12 4.3-2.41 9.44.57 12.74 1.86 2.05 4.92 2.65 7.65 2.19a25 25 0 0 0 7.65-3.12c4.28-2.33 8.62-4.7 12.08-8.12 2.29-2.27 4.14-4.94 6.32-7.31a70.17 70.17 0 0 1 14.37-11.71c4.22-2.59 8.55-1 13 .71 9.69 3.68 18.68 10.6 29.38 10.4Z"
      opacity={0.1}
    />
    <path
      d="M441.75 220.91a8.72 8.72 0 0 0 5.1-1.38c2.08-1.55 2.75-4.34 3.22-6.89 1.13-6 2-12.4 0-18.22-1.3-3.85-3.77-7.17-5.56-10.82-3.91-8-4.6-17.56-10.16-24.48-3.48-4.33-15 .67-20.13-1.53-11-4.72-16.38-15-28.32-15a43.1 43.1 0 0 0-13 1.66c-5.34 1.68-10.06 4.9-14.44 8.38-7.64 6.07-15.08 14.4-14.4 24.14.44 6.22 4.14 11.66 6.32 17.5 3.66 9.78 3 20.73.35 30.83-1.12 4.3-2.41 9.44.57 12.74 1.86 2.05 4.92 2.65 7.65 2.19a25 25 0 0 0 7.65-3.12c4.28-2.33 8.62-4.7 12.08-8.12 2.29-2.27 4.14-4.94 6.32-7.31a70.17 70.17 0 0 1 14.51-11.67c4.22-2.59 8.55-1 13 .71 9.55 3.65 18.54 10.59 29.24 10.39Z"
      fill="#632652"
    />
    <path
      d="M425.82 433.32a134.37 134.37 0 0 1-1.31-29.15 361.13 361.13 0 0 0 .39-40c-.59-15.62-1.79-31.06-2.94-43.33a72.49 72.49 0 0 0-24.11-47.75c-3.05-2.69-5.77-4.66-7.58-5.15-2.29-.63-5.1-2.5-7.88-4.77-9.35-7.64 2.53 7.24 5.59 9.92a72.49 72.49 0 0 1 24.11 47.75c1.15 12.26 2.35 27.71 2.94 43.33a361.13 361.13 0 0 1-.39 40 134.37 134.37 0 0 0 1.35 29.18c5.12 35.54 20.38 70.88 20.38 70.88s-74.48 15.42-109.13 17.07c27.16 2 119-17.07 119-17.07s-15.3-35.37-20.42-70.91Z"
      opacity={0.05}
    />
    <path
      d="M516.64 439.69c-20.41 23.7-50 7.9-50 7.9-1.2-2-10.7-7.43-18-11.36-4.65-2.53-8.38-4.44-8.38-4.44l15.14-12.51 7.66 4 11.45 5.89s62.54-13.18 42.13 10.52Z"
      fill="#f7c4a7"
    />
    <path d="m463.08 423.24-14.42 13c-4.65-2.53-8.38-4.44-8.38-4.44l15.14-12.51Z" opacity={0.1} />
    <path
      d="M365.88 335.67s26.33 88.88 77 102.7l19.75-17.78s-37-46.77-38.23-66.18c-.47-7.17-2.65-17.53-5.22-27.74-7.88-31.36-54.3-25.14-53.39 7.18q.05.9.09 1.82Z"
      fill="#575988"
    />
    <path d="M314.86 422.24s17.12-13.83 32.92-3.29 38.84 9.22 42.13 9.88" opacity={0.05} />
  </svg>
);

export default WomanArcade;
